export const GLOBAL_SANDBOXES_PATH = '/sandboxes';
export const GLOBAL_SANDBOXES_GETTING_STARTED_QUERY_PARAM = 'getting-started';
export const GLOBAL_SANDBOXES_LIST_PATH = '/sandboxes/org-sandboxes';
export const GLOBAL_SANDBOX_DRAWER_PATH =
  '/sandboxes/org-sandboxes/:sandboxId/:tab(overview|logs)?';
export const GLOBAL_SNAPSHOTS_PATH = '/sandboxes/snapshots';
export const GLOBAL_SNAPSHOT_DRAWER_PATH = '/sandboxes/snapshots/:snapshotId';

// Keep the original global detail route available for links created before the
// Sandboxes shell moved org-scoped details into a drawer.
export const GLOBAL_SANDBOX_DETAIL_PATH =
  '/sandboxes/:entityName/:sandboxId/:tab(overview|logs)?';

// Keep every global Sandboxes URL on one top-level Route. SandboxesRouter owns
// the persistent shell and keeps the org list mounted beneath its drawer.
export const GLOBAL_SANDBOXES_PATHS = [
  GLOBAL_SNAPSHOT_DRAWER_PATH,
  GLOBAL_SNAPSHOTS_PATH,
  GLOBAL_SANDBOX_DRAWER_PATH,
  GLOBAL_SANDBOXES_LIST_PATH,
  GLOBAL_SANDBOX_DETAIL_PATH,
  GLOBAL_SANDBOXES_PATH,
];
